import { g as l } from "../../utils-BOfnFgIH.js";
import { I as o } from "../../constants-DeVuDy8J.js";
import { createElementBlock as a, openBlock as n, normalizeClass as r, createElementVNode as e, createStaticVNode as d } from "vue";
import { _ as c } from "../../_plugin-vue_export-helper-CHgC5LLL.js";
const u = {
  name: "DtIconMicrosoftDynamics365",
  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: String,
      default: "500",
      validator: (t) => Object.keys(o).includes(t)
    },
    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: void 0
    }
  },
  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ["loaded"],
  computed: {
    iconSizeClass() {
      return o[this.size];
    },
    ariaHidden() {
      return this.ariaLabel ? "false" : "true";
    },
    dataQA() {
      return this.$attrs["data-qa"] ?? "dt-icon";
    }
  },
  created() {
    this.$emit("loaded"), this.uniqueID = l();
  }
}, f = ["aria-label", "data-qa", "aria-hidden"], _ = /* @__PURE__ */ e("mask", {
  id: "a",
  style: { "mask-type": "alpha" },
  maskUnits: "userSpaceOnUse",
  x: "4",
  y: "2",
  width: "15",
  height: "20"
}, [
  /* @__PURE__ */ e("path", {
    d: "M18.583 8.328c0-.88-.553-1.666-1.382-1.962L5.114 2.049A.833.833 0 0 0 4 2.834v6.564c0 .352.221.666.553.784l5.417 1.935a.833.833 0 0 0 1.113-.785V7.563c0-.29.291-.492.564-.39l1.42.535a2.083 2.083 0 0 1 1.35 1.95v1.641l-6.12 2.236a.833.833 0 0 0-.547.783v6.559c0 .578.576.98 1.12.782l8.345-3.05a2.083 2.083 0 0 0 1.368-1.956V8.328z",
    fill: "#fff"
  })
], -1), p = { mask: "url(#a)" }, h = ["fill"], m = /* @__PURE__ */ e("g", { filter: "url(#c)" }, [
  /* @__PURE__ */ e("path", {
    d: "M18.583 8.401c0 .875-.546 1.659-1.368 1.959L7.75 13.818v8.333l10.833-3.958V8.401z",
    fill: "currentColor",
    "fill-opacity": ".24"
  })
], -1), g = /* @__PURE__ */ e("g", { filter: "url(#d)" }, [
  /* @__PURE__ */ e("path", {
    d: "M18.583 8.735c0 .875-.546 1.658-1.368 1.958L7.75 14.152v8.333l10.833-3.959V8.735z",
    fill: "currentColor",
    "fill-opacity": ".32"
  })
], -1), y = ["fill"], B = ["fill"], v = /* @__PURE__ */ e("path", {
  opacity: ".5",
  d: "m14.417 11.302-3.335 1.22v4.887c0 .29.29.492.563.39l1.423-.536a2.083 2.083 0 0 0 1.349-1.95v-4.011z",
  fill: "#B0ADFF"
}, null, -1), F = ["id"], I = /* @__PURE__ */ e("stop", { "stop-color": "#0B53CE" }, null, -1), S = /* @__PURE__ */ e("stop", {
  offset: "1",
  "stop-color": "#7252AA"
}, null, -1), D = [
  I,
  S
], U = ["id"], x = /* @__PURE__ */ e("stop", { "stop-color": "#2266E3" }, null, -1), z = /* @__PURE__ */ e("stop", {
  offset: "1",
  "stop-color": "#AE7FE2"
}, null, -1), k = [
  x,
  z
], q = ["id"], G = /* @__PURE__ */ e("stop", { "stop-color": "#94B9FF" }, null, -1), b = /* @__PURE__ */ e("stop", {
  offset: ".288",
  "stop-color": "#94B9FF",
  "stop-opacity": ".524"
}, null, -1), L = /* @__PURE__ */ e("stop", {
  offset: "1",
  "stop-color": "#538FFF",
  "stop-opacity": "0"
}, null, -1), M = [
  G,
  b,
  L
], O = /* @__PURE__ */ d('<filter id="c" x="6.95" y="7.601" width="12.433" height="15.35" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"><feFlood flood-opacity="0" result="BackgroundImageFix"></feFlood><feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape"></feBlend><feGaussianBlur stdDeviation=".4" result="effect1_foregroundBlur"></feGaussianBlur></filter><filter id="d" x="-.25" y=".735" width="26.833" height="29.75" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"><feFlood flood-opacity="0" result="BackgroundImageFix"></feFlood><feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape"></feBlend><feGaussianBlur stdDeviation="4" result="effect1_foregroundBlur"></feGaussianBlur></filter>', 2);
function V(t, w, s, E, $, i) {
  return n(), a("svg", {
    "aria-label": s.ariaLabel,
    class: r([i.iconSizeClass, "d-icon d-icon--microsoft-dynamics-365"]),
    "data-qa": i.dataQA,
    "aria-hidden": i.ariaHidden,
    role: "img",
    "data-name": "Microsoft Dynamics 365",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    _,
    e("g", p, [
      e("path", {
        d: "M4 1.652 18.583 6.86v7.15c0 .577-.57.98-1.113.786l-3.053-1.09v-4.05c0-.867-.538-1.644-1.35-1.95l-1.42-.533a.417.417 0 0 0-.564.39v4.952L4 9.985V1.652z",
        fill: `url(#${t.uniqueID}b)`
      }, null, 8, h),
      m,
      g,
      e("path", {
        d: "M18.583 8.318c0 .875-.546 1.658-1.368 1.959L7.75 13.735v8.333l10.833-3.958V8.318z",
        fill: `url(#${t.uniqueID}e)`
      }, null, 8, y),
      e("path", {
        opacity: ".5",
        d: "M18.583 8.318c0 .875-.546 1.658-1.368 1.959L7.75 13.735v8.333l10.833-3.958V8.318z",
        fill: `url(#${t.uniqueID}f)`
      }, null, 8, B),
      v
    ]),
    e("defs", null, [
      e("linearGradient", {
        id: `${t.uniqueID}b`,
        x1: "9.426",
        y1: "1.652",
        x2: "13.304",
        y2: "11.802",
        gradientUnits: "userSpaceOnUse"
      }, D, 8, F),
      e("linearGradient", {
        id: `${t.uniqueID}e`,
        x1: "14.862",
        y1: "21.337",
        x2: "14.862",
        y2: "9.238",
        gradientUnits: "userSpaceOnUse"
      }, k, 8, U),
      e("linearGradient", {
        id: `${t.uniqueID}f`,
        x1: "18.583",
        y1: "13.69",
        x2: "14.433",
        y2: "13.69",
        gradientUnits: "userSpaceOnUse"
      }, M, 8, q),
      O
    ])
  ], 10, f);
}
const H = /* @__PURE__ */ c(u, [["render", V]]);
export {
  H as default
};
//# sourceMappingURL=microsoft-dynamics-365.js.map
